import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import avatar from "../../assets/images/users/user-dummy-img.jpg";

const UserProfile = () => {
  document.title = "Profil | Sefer";

  const user = JSON.parse(sessionStorage.getItem("authUser"));
  const isAdmin = user.role === "Admin" ? true : false

  const [username, setUsername] = useState();

  useEffect(() => {
    setUsername(user.username);
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3"> <img src={avatar} alt="" className="avatar-md rounded-circle img-thumbnail" /> </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <p className="mb-0">Username: {" " + username}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>          
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;